import { render } from "./Auth.vue?vue&type=template&id=243d6e09&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=ts"
export * from "./Auth.vue?vue&type=script&lang=ts"

import "./Auth.vue?vue&type=style&index=0&id=243d6e09&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-243d6e09"

export default script